module.exports = {
  siteMetadata: {
    title: "TLF Research",
    author: {
      name: "The Bigger Boat",
      summary: "TBB Gatsby / Storyblok",
    },
    description: "The Leadership Factor Research Gatsby site",
    siteUrl: "https://www.tlfresearch.com",
    image:
      "https://a.storyblok.com/f/131443/2501x1309/b2bd02bf0c/doing-best-what-matters-most.jpg",
    noindex: "index,follow",
  },
  plugins: [
    {
      resolve: 'gatsby-plugin-load-script',
      options: {
        src: "https://plausible.io/js/script.js",
        "data-domain": "tlfresearch.com",
        defer: true,
      }
    },    
    "gatsby-plugin-postcss",
    {
      resolve: "gatsby-source-storyblok",
      options: {
        accessToken: "g3tX6rinSbVjIFq8c4UrZwtt",
        homeSlug: "home",
        version: process.env.NODE_ENV === "production" ? "published" : "draft",
      },
    },
    {
      resolve: "gatsby-plugin-google-tagmanager",
      options: {
        id: "GTM-M4GHX4T",

        // Include GTM in development.
        //
        // Defaults to false meaning GTM will only be loaded in production.
        includeInDevelopment: false,

        // datalayer to be set before GTM is loaded
        // should be an object or a function that is executed in the browser
        //
        // Defaults to null
        defaultDataLayer: { platform: "gatsby" },

        // Name of the event that is triggered
        // on every Gatsby route change.
        //
        // Defaults to false
        enableWebVitalsTracking: true,
      },
    },
    {
      resolve: `gatsby-plugin-google-gtag`,
      options: {
        trackingIds: [
          "UA-2429309-19", // Google Analytics / GA
          "G-B46WMEPG8Z",
          "UA-11354329-56", // TBB Test Property added by Lee 18.10.22 Google Analytics / GA
          "G-8QS8MXXR9P", // TBB Test Property added by Lee 18.10.22 Google Analytics / GA
        ],
        pluginConfig: {
          // Puts tracking script in the head instead of the body
          head: true,
        },
      },
    },
    {
      resolve: "gatsby-plugin-react-svg",
      options: {
        rule: {
          include: /images/,
        },
      },
    },
    {
      resolve: `gatsby-plugin-algolia`,
      options: {
        appId: "2CSOP59JJ4",
        apiKey: "fa4fe9053a6fb630ecbab4d0a0ceddb7",
        queries: require("./src/utils/algolia-queries"),
      },
    },
    {
      resolve: "gatsby-source-shopify",
      options: {
        password: "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",
        storeUrl: "tlf-research-uk.myshopify.com",
        storefrontAccessToken: "6a208563f7ea2df61048f3bab811c33c",
        useBulkOperations: false,
      },
    },
    {
      resolve: `gatsby-plugin-breadcrumb`,
      options: {
        useAutoGen: true,
        trailingSlashes: true,
      },
    },
    "gatsby-plugin-root-import",
    "gatsby-plugin-react-helmet",
    "gatsby-plugin-image",
    {
      resolve: "gatsby-plugin-webpack-bundle-analyser-v2",
      options: {
        devMode: true,
      },
    },
    {
      resolve: `gatsby-plugin-sitemap`,
      options: {
        excludes: [
          "/404-layouts/",
          "/gated-content/thank-you/",
          "/event-signup/thank-you-register/",
          "/thank-you-newsletter/",
          "/thank-you-order/",
          "/thank-you/",
        ],
      },
    },
    {
      resolve: `gatsby-plugin-netlify`,
      options: {
        headers: {
          "/*": [
            "Access-Control-Allow-Origin: *",
            "Content-Security-Policy: frame-ancestors https://app.storyblok.com/",
            "X-Frame-Options: SAMEORIGIN",
          ],
        },
      },
    },
    {
      resolve: `gatsby-plugin-canonical-urls`,
      options: {
        siteUrl: `https://www.tlfresearch.com`,
      },
    },
    "gatsby-plugin-force-trailing-slashes",
    {
      resolve: "@sentry/gatsby",
      options: {
        dsn: "https://23111ead04c34d52badbadb1dbdd4493@o1083877.ingest.sentry.io/6093715",
        sampleRate: 0.7,
      },
    },
    {
      resolve: "gatsby-plugin-robots-txt",
      options: {
        host: "https://www.tlfresearch.com",
        sitemap: "https://www.tlfresearch.com/sitemap/sitemap-0.xml",
        policy: [
          {
            userAgent: "*",
            allow: "/",
          },
          {
            userAgent: "Googlebot",
            disallow: ["*refinementList*"],
          },
          {
            userAgent: "adsbot-google",
            disallow: ["*refinementList*"],
          },
        ],
      },
    },    
  ],
};
